import React, { PureComponent } from 'react';
import { Modal, Button, Select, Input, VSpacer, ModalAlert, Text } from '@mqd/volt-base';
import PropTypes from 'prop-types';

class EditRiskRatingModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      error: '',
    };
  }

  componentDidMount() {
    const { values, isEdit } = this.props;
    isEdit &&
      this.setState({
        ...values,
      });
  }

  resetState() {
    this.setState({
      value: '',
    });
  }

  renderErrorModal() {
    const { error } = this.state;
    if (!error) return null;
    return (
      <ModalAlert type="danger" title="Error" hideModal={() => this.setState({ error: '' })}>
        <Text>{error}</Text>
      </ModalAlert>
    );
  }

  render() {
    const { options, handleSave, hideModal } = this.props;
    const { value } = this.state;
    const handleHideModal = () => {
      hideModal && hideModal();
      this.resetState();
    };
    const dropDownWrap = {
      width: '99.9%',
      height: '140px',
    };

    return (
      <Modal
        heading="Edit Risk Rating"
        hideModal={handleHideModal}
        testId="edit_risk_rating_modal"
        disableOverFlow
        footerButtons={[
          <Button
            key="save"
            onClick={() => {
              if (!value) return this.setState({ error: 'Risk rating cannot be empty' });
              if (handleSave) {
                handleSave({ value });
              }
              this.resetState();
            }}
          >
            Save
          </Button>,
        ]}
      >
        {this.renderErrorModal()}
        <Select
          label="Rating"
          placeholder="Select Rating"
          dropDownWrap={dropDownWrap}
          value={this.state.value}
          options={options}
          onChange={(e) => this.setState({ value: e })}
        />
        <VSpacer factor={4} />
      </Modal>
    );
  }
}

EditRiskRatingModal.propTypes = {
  options: PropTypes.array,
  handleCancel: PropTypes.func,
  handleSave: PropTypes.func,
  hideModal: PropTypes.func,
  isEdit: PropTypes.bool,
  values: PropTypes.object,
};

EditRiskRatingModal.defaultProps = {
  options: [],
  handleCancel: () => {},
  handleSave: () => {},
  hideModal: () => {},
  values: {
    value: '',
  },
  isEdit: false,
};

export default EditRiskRatingModal;
